export { FrostedSurface } from './FrostedSurface';
